import styles from './BreakingNewsAlert.module.scss'
import { Alert, Container } from 'react-bootstrap'
import React, { useEffect, useRef } from 'react'

interface Props {
  className?: string
  onHeightChange?: (height: number) => void
}

const BreakingNewsAlert = ({ className = '', onHeightChange }: Props) => {
  const ref = useRef<HTMLDivElement>(null)

  // report the height so the navbar can be placed below the alert
  useEffect(() => {
    if (!ref.current || !onHeightChange) return
    const observer = new ResizeObserver(([entry]) => onHeightChange(entry.target.getBoundingClientRect().height))
    observer.observe(ref.current)
    return () => observer.disconnect()
  }, [onHeightChange])

  return (
    <>
      <Container fluid ref={ref} className={`${styles.root} ${className ? styles[className] : ''}`}>
        <Alert variant={'danger'} className={styles.alert}>
          Aktuell können aus technischen Gründen keine Online-Buchungen getätigt werden. Gerne nehmen wir Ihre Buchung telefonisch oder per E-Mail
          entgegen.
        </Alert>
      </Container>
    </>
  )
}

export default BreakingNewsAlert
